import axios from 'axios';
import { ENDPOINTS } from './endpoints';

export const viewFileFromS3 = async (path) => {
  try {
    const response = await axios.post(`${ENDPOINTS.S3_SERVICE.VIEW_FILE_FROM_S3}`, { path });
    return response;
  } catch (error) {
    throw error;
  }
}